import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
  selector: 'app-environment-custom-package',
  templateUrl: './environment-custom-package.component.html',
  styleUrl: './environment-custom-package.component.scss',
  standalone: false
})
export class EnvironmentCustomPackageComponent {
    private destroyRef = inject(DestroyRef);
    instanceId: any;
    data: any;
    externalPackages: any
    dataSourceExternalPackages: any;
    expandedPackageElement: any;
    dataSourceInnerImages: any;
    dataSourceInnerPackages: any;
    tableColumns: string[] = ['menu', 'component', 'arrow'];
    innerTableColumns: string[] = ['name', 'path', 'version'];
    showSpinner:boolean;
   constructor(
    private instanceService: InstancesService,
    private solutionsService: SolutionsService,
    private toastrService: CustomToastrService,
    private activatedRoute: ActivatedRoute,
  ) { }
    ngOnInit(){
         this.showSpinner = true;
         this.instanceId = this.activatedRoute.snapshot.params.instanceId;
         this.instanceService.getInstanceById(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instance: any) => {
        if(instance) {
          this.data = instance;
        }
        if(this.data?.packageReferenceId){
        this.getExternalPackages(); 
        } else {
          this.showSpinner = false;
        }
    });
    }
    getExternalPackages(): void {
    this.solutionsService.getReferencePackagesById(this.data?.solutionId, this.data?.packageReferenceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.showSpinner = false;
      this.externalPackages = data;
      this.externalPackages?.references.forEach(data => data.arrowClick = false);
      this.dataSourceExternalPackages = new MatTableDataSource(this.externalPackages?.references);
    },
    (error) => {
      this.showSpinner = false;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  onExternalPackageArrowClick(data): void {
    this.expandedPackageElement = this.expandedPackageElement === data ? null : data;
    this.externalPackages.references.find(item => item.component === data.component).arrowClick = !this.externalPackages?.references?.find(item => item.component === data.component)?.arrowClick;
    this.externalPackages.references?.forEach(item =>  {
      if(item.component !== data.component) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInnerImages = this.externalPackages?.references?.find(item => item.component === data.component)?.images;
    this.dataSourceInnerPackages = this.externalPackages?.references?.find(item => item.component === data.component)?.packages;
  }
}
